<template>
    <div class="store-con">
        <div class="status-section">
            <div class="status-text">
                <div class="indicator-bar"></div>
                <text v-if="countdownText !== '已过期'"> {{ getStatusText(orderInfo.status) }}</text>
                <!-- 倒计时待付款显示 -->
                <text class="time" v-if="orderInfo.status == 0">{{ countdownText }}</text>
            </div>
        </div>
        <div class="store-confirm">
            <!-- 收货信息 -->
            <div class="address-section">
                <h3 class="section-title">收货信息</h3>
                <div class="address-content">
                    <div class="address-item">
                        <span class="label">收货店名：</span>
                        <span class="value">{{ orderInfo.shop_name }}</span>
                    </div>
                    <div class="address-item">
                        <span class="label">联系人：</span>
                        <span class="value">{{ orderInfo.delivery_name }}</span>
                    </div>
                    <div class="address-item">
                        <span class="label">收货地址：</span>
                        <span class="value">{{ orderInfo.delivery_address }}</span>
                    </div>
                </div>
            </div>
            <!-- 商品列表 -->
            <div class="goods-section">
                <div class="goods-item" v-for="(item, index) in orderInfo.shop_order_infos" :key="index" @click="handleClick(item)">
                    <div class="goods-image">
                        <img :src="comapi.getImageUrl(item.cover_image)" />
                    </div>
                    <div class="goods-info">
                        <div class="goods-name">{{ item.product_name }}({{ item.spec_name }})</div>
                        <div class="goods-spec">规格：{{ item.unit }}</div>
                        <div class="goods-price-row">
                            <div class="goods-price">￥{{ item.shop_purchase_price / 100 }}</div>
                            <div class="goods-quantity">x{{ item.num }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 订单信息卡片 -->
            <div class="info-card order-info-card">
                <div class="row">
                    <text class="label">订单编号：</text>
                    <div class="order-no-container">
                        <text class="value">{{ orderInfo.uuid }}</text>
                        <div class="copy-btn" @click="copyOrderNo(orderInfo.uuid)">复制</div>
                    </div>
                </div>
                <div class="row">
                    <text class="label">下单时间：</text>
                    <text class="value">{{ orderInfo.created_at }}</text>
                </div>
                <div class="row" v-if="orderInfo.remark != ''">
                    <text class="label">订单备注：</text>
                    <text class="value">{{ orderInfo.remark }}</text>
                </div>
                <div class="row">
                    <text class="label">订单金额：</text>
                    <text class="value">￥{{ orderInfo.total_money / 100 }}</text>
                </div>
                <div class="row">
                    <text class="label">支付方式：</text>
                    <text class="value">{{ orderInfo.pay_type == 1 ? '线上支付' : '线下支付' }}</text>
                </div>
                <div class="row" v-if="orderInfo.cancel_remark != ''">
                    <text class="label">取消原因：</text>
                    <text class="value">{{ orderInfo.cancel_remark }}</text>
                </div>
                <div class="row" v-if="orderInfo.refund_reason != ''">
                    <text class="label">退款原因：</text>
                    <text class="value">{{ orderInfo.refund_reason }}</text>
                </div>
                <div class="ordership" @click="openStoreShipment" v-if="orderInfo.status === 4||orderInfo.status === 7">
                    该订单已发{{orderInfo.shop_order_shipment_num}}个包裹，查看包裹详情
                    <img src="../../assets/img/icons/icon_right.png" class="icon-img" alt="">
                </div>
            </div>
        </div>
        <div class="pay_order_con" v-if="orderInfo.status === 0&&orderInfo.pay_type == 2">
            <van-uploader v-if="pay_image == ''" :after-read="afterRead">
                <van-button icon="plus" type="primary" color="#D6B788" size="small">上传支付凭证</van-button>
            </van-uploader>
            <img class="payimgclass" :src="comapi.getImageUrl(pay_image)" alt="" v-if="pay_image != ''"
                @click="previewImage">
        </div>
        <div class="height-page"></div>
        <div class="footer-bar">
            <!-- 待付款 -->
            <template v-if="orderInfo.status === 0">
                <div class="btn outline" @click="handleAction('cancel')">取消订单</div>
                <div class="btn solid" @click="handleAction('pay')" v-if="orderInfo.pay_type == 1">去支付</div>
                <div class="btn solid" @click="handleAction('payuploader')" v-if="orderInfo.pay_type == 2">完成支付</div>
            </template>
            <!-- 待接单 -->
            <template v-else-if="orderInfo.status === 1">
                <div class="btn outline" @click="handleAction('black')">返回</div>
                <div class="btn solid" @click="handleAction('applyRefund')">申请退款</div>
            </template>
            <template v-else>
                <div class="btn outline" @click="handleAction('black')">返回</div>
                <div class="btn solid" @click="handleAction('confirm')">再来一单</div>
            </template>
        </div>
        <van-dialog v-model:show="DialogRemark" :title="DialogTitle" show-cancel-button confirm-text="确认"
            @confirm="handleApply">
            <van-field v-model="RemarkValue" rows="2" autosize type="textarea" maxlength="50" placeholder="请输入原因"
                show-word-limit />
        </van-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import comapi from "@/utils/api/com";
import storeapi from "@/utils/api/store";
import { showToast, showImagePreview, showFailToast } from "vant";
import { useRouter, useRoute } from 'vue-router';
const router = useRouter();
const route = useRoute();
const order_uuid = route.query.order_uuid || '';

const countdownText = ref('00:00:00');//状态文本
const countdownTimer = ref(null);//倒计时定时器
const orderStatus = ref('');
const orderInfo = ref({});
const DialogRemark = ref(false);
const DialogTitle = ref('');
const RemarkValue = ref('');
const pay_image = ref('');
const jspay_url = ref('');
onMounted(() => {
    getorderdetail()
});

onUnmounted(() => {
    clearCountdown();
});
const getorderdetail = () => {
    storeapi.getorderdetail({
        uuid: order_uuid
    }).then(res => {
        if (res.code == 200) {
            orderInfo.value = res.data;
            if (res.data.status === 0 && res.data.pay_type == 1) {
                getpayurl()
            }
            if (res.data.status === 0) {
                // 启动倒计时定时器
                startCountdown();
            }
        }
    })
}
const getStatusText = (status) => {
    if (status === -1) {
        return '已取消';
    }
    const statusMap = {
        '0': '待支付',
        '1': '待接单',
        '2': '待发货',
        '3': '退款中',
        '4': '已完成',
        '5': '已退款',
        '6': '部分发货',
        '7': '已发货'
    };
    return statusMap[status] || status;
};
// 启动倒计时定时器
const startCountdown = () => {
    // 立即计算一次倒计时
    updateCountdown();
    // 每秒更新一次
    countdownTimer.value = setInterval(() => {
        updateCountdown();
    }, 1000);
};
//复制单号
const copyOrderNo = async (uuid) => {
    try {
        await navigator.clipboard.writeText(uuid);
        showToast('复制成功');
    } catch (err) {
        console.error('复制失败:', err);
        showToast('复制失败，请手动复制');
    }
};
//上传支付凭证
const afterRead = (file) => {
    comapi.uploadFile(file.file).then(res => {
        if (res.code == 200) {
            showToast('上传成功');
            pay_image.value = res.data;
        }
    })
}
//预览图片
const previewImage = () => {
    if (pay_image.value) {
        showImagePreview({
            images: [comapi.getImageUrl(pay_image.value)]
        });
    }
};
// 更新倒计时显示
const updateCountdown = () => {
    try {
        // 解析订单创建时间，处理可能的格式问题
        let createTimeStr = orderInfo.value.created_at;
        // 替换可能的多个空格为单个空格，确保格式正确
        createTimeStr = createTimeStr.replace(/\s+/g, ' ');

        // 直接创建Date对象并添加30分钟
        let createTime = new Date(createTimeStr);
        if (isNaN(createTime.getTime())) {
            countdownText.value = '已过期';
            return;
        }

        createTime.setMinutes(createTime.getMinutes() + 10);
        let now = new Date();

        // 直接计算时间差，避免不必要的字符串转换
        let diff = createTime - now;

        if (diff <= 0) {
            countdownText.value = "已过期";
            // 倒计时结束，清除定时器
            clearCountdown();
            return;
        }

        // 计算时分秒
        let h = Math.floor(diff / (1000 * 60 * 60));
        let m = Math.floor(diff / (1000 * 60)) % 60;
        let s = Math.floor(diff / 1000) % 60;

        // 补零并确保为数字
        h = h < 10 ? '0' + h : h;
        m = m < 10 ? '0' + m : m;
        s = s < 10 ? '0' + s : s;

        countdownText.value = `${h}:${m}:${s}`;
    } catch (error) {
        console.error('倒计时计算错误:', error);
        countdownText.value = '已过期';
    }
};
// 清除倒计时定时器
const clearCountdown = () => {
    if (countdownTimer.value) {
        clearInterval(countdownTimer.value);
        countdownTimer.value = null;
    }
};
//获取支付连接
const getpayurl = () => {
    storeapi.getpayurl({
        uuid: order_uuid
    }).then(res => {
        if (res.code == 200) {
            jspay_url.value = res.data.jspay_url
        }
    })
};
const handleAction = (action) => {
    orderStatus.value = action;
    if (action === 'confirm') {
        // 再来一单
        const buy_product_list = orderInfo.value.shop_order_infos.map(item => ({
            product_uuid: item.product_uuid,
            product_sku_uuid: item.product_sku_uuid,
            num: item.num,
            product_name: item.product_name,
            spec_name: item.spec_name,
            unit: item.unit,
            cover_image: item.cover_image,
            shop_purchase_price: item.shop_purchase_price || '0.00',
        }));
        localStorage.setItem('order_goods_list', JSON.stringify(buy_product_list));
        setTimeout(() => {
            router.push({
                path: '/store_confirm',
            })
        }, 500);
    } else if (action === 'black') {
        // 返回
        router.back();
    } else if (action == 'applyRefund') {
        DialogRemark.value = true
        DialogTitle.value = "申请退款"
    } else if (action == 'cancel') {
        DialogRemark.value = true
        DialogTitle.value = "取消订单"
    } else if (action == 'payuploader') {
        //上传支付凭证
        if (pay_image.value == '') {
            showFailToast('请上传支付凭证');
            return;
        }
        storeapi.uploadPayImage({
            uuid: order_uuid,
            pay_vouchers: pay_image.value
        }).then(res => {
            if (res.code == 200) {
                showToast('上传成功');
                getorderdetail()
            }
        })
    } else if (action == 'pay') {
        if (jspay_url.value == '') {
            showFailToast('请先获取支付连接');
            return;
        }
        window.location.href = jspay_url.value;
    }
}
const handleApply = () => {
    if (orderStatus.value == "cancel") {
        storeapi.cancel({
            uuid: order_uuid,
            cancel_remark: RemarkValue.value
        }).then(res => {
            if (res.code == 200) {
                showToast('取消订单成功');
                getorderdetail()
            }
        })
    }
    if (orderStatus.value == "applyRefund") {
        storeapi.refund({
            uuid: order_uuid,
            cancel_remark: RemarkValue.value
        }).then(res => {
            if (res.code == 200) {
                showToast('申请退款成功');
                getorderdetail()
            }
        })
    }
};
//打开包裹详情
const openStoreShipment = () => {
    router.push({
        path: '/store_shipment',
        query: {
            order_uuid: order_uuid
        }
    })
};
// 处理商品点击
const handleClick = (item) => {
    router.push({ path: '/store_shop_detail', query: { product_uuid: item.product_uuid } })
}
</script>

<style lang="less" scoped>
.store-con {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 80px;

    .status-section {
        background-color: rgba(220, 187, 137, 0.15);
        padding: 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .status-text {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 600;
            color: #3C211F;

            .indicator-bar {
                width: 4px;
                height: 17px;
                background-color: #DCBB89;
                margin-right: 4px;
                border-radius: 15px;
            }

            .time {
                margin-left: 5px;
                color: #FF383C;
            }
        }
    }

    .store-confirm {
        padding: 17px;

    }

    .pay_order_con {
        text-align: center;

        .payimgclass {
            width: 50%;
        }
    }

    .height-page {
        height: 60px;
    }

    /* 底部栏 */
    .footer-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #FFFFFF;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 15px;
        padding-bottom: calc(10px + env(safe-area-inset-bottom));
        box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.05);
        z-index: 99;

        .btn {
            width: 105px;
            height: 35px;
            line-height: 35px;
            text-align: center;
            font-size: 15px;
            border-radius: 2px;
            margin-left: 10px;

            &.outline {
                background-color: #FFFFFF;
                border: 1px solid #CCC;
                color: #666;
            }

            &.solid {
                background-color: #D6B788;
                border: 1px solid #D6B788;
                color: #FFFFFF;
            }
        }
    }

    .section-title {
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;
    }

    .address-section {
        background-color: #fff;
        padding: 10px;
        margin-bottom: 10px;
        border-radius: 8px;

        .address-content {
            .address-item {
                margin-bottom: 8px;
                display: flex;
                align-items: center;

                .label {
                    font-size: 14px;
                    color: #666;
                    width: 80px;
                }

                .value {
                    font-size: 14px;
                    color: #333;
                    flex: 1;
                }

                .switch-btn {
                    font-size: 14px;
                    color: #ff7123;
                    margin-left: 10px;
                }
            }
        }
    }

    .goods-section {
        background-color: #fff;
        padding: 16px;
        margin-bottom: 10px;
        border-radius: 8px;

        .goods-item {
            display: flex;
            margin-bottom: 16px;

            .goods-image {
                width: 80px;
                height: 80px;
                margin-right: 12px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 4px;
                }
            }

            .goods-info {
                flex: 1;

                .goods-name {
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 4px;
                }

                .goods-spec {
                    font-size: 12px;
                    color: #999;
                    margin-bottom: 8px;
                }

                .goods-price-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .goods-price {
                        font-size: 16px;
                        color: #ff7123;
                        font-weight: bold;
                    }

                    .goods-quantity {
                        font-size: 14px;
                        color: #666;
                    }
                }
            }
        }
    }

    .info-card {
        background-color: #FFFFFF;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 10px;
    }

    .order-info-card {
        .order-no-container {
            display: flex;
            align-items: center;
        }

        .ordership {
            display: flex;
            align-items: center;
            color: #FF7123;
            font-size: 14px;
            font-weight: bold;

            .icon-img {
                margin-left: 5px;
                margin-top: 2px;
                width: 13px;
                height: 13px;
            }
        }

        .row {
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            font-size: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .label {
                color: #999;
                width: 75px;
            }

            .value {
                color: #333;
                flex: 1;
            }

            .copy-btn {
                border: 1px solid #CCC;
                color: #666;
                font-size: 15px;
                height: 25px;
                line-height: 25px;
                width: 50px;
                border-radius: 4px;
                margin-left: 10px;
                text-align: center;
            }
        }
    }
}
</style>